import { sharedEnvironment } from '@vinnova/environments';

export const environment = {
  production: sharedEnvironment.sys.production,
  name: sharedEnvironment.sys.name,
  etjansterCommonUrl: sharedEnvironment.sys.etjansterCommonApiUrl,
  cookieDomain: sharedEnvironment.sys.cookieDomain,
  utlysningsbyggareUrl: sharedEnvironment.sys.utlysningsbyggareUrl,
  utlysningsbyggareApiUrl: `${sharedEnvironment.sys.utlysningsbyggareApiUrl}`,
  forhandsgranskaUrl: sharedEnvironment.sys.forhandsgranskaUrl,
  etjansterCommonApiUrl: `${sharedEnvironment.sys.etjansterCommonApiUrl}/api`,
  resourceStringUrl: `${sharedEnvironment.sys.gatewayUrl}/resourcestring/forhandsgranska`,
  sprakHanteringApiUrl: `${sharedEnvironment.sys.gatewayUrl}/resourcestring`,
  logServiceApiUrl: `${sharedEnvironment.sys.gatewayUrl}/logger`,
  externalLinks: sharedEnvironment.sys.externalLinks,
  baseGatewayUrl: sharedEnvironment.sys.gatewayUrl,
  apimSubscriptionKey: sharedEnvironment.sys.apimSubscriptionKey,
  tinyMceApiKey: sharedEnvironment.sys.tinyMceApiKey,
  usePremiumTinyMceFeatures: true,
  etjansterCommonApiScope:
    sharedEnvironment.sys.azureAd.etjansterCommonApiScope,
  featureUrl: `${sharedEnvironment.sys.utlysningsbyggareApiUrl}/feature`,

  msalConfig: {
    ...sharedEnvironment.msalConfig(
      sharedEnvironment.sys.utlysningsbyggareApiUrl,
      '39175e04-8fc8-4d1c-892a-2f3cb242d525',
      '35cbeef4-867f-44df-a7f5-5d81162bce09',
      sharedEnvironment.sys.utlysningsbyggareUrl,
    ),
    allowRedirectInIframe: false,
  },
};
